import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms'
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PreCheckoutStatus } from 'src/app/models/pre-checkout-status.model';
import { AlertService } from 'src/app/services/alert.service';
import { PreCheckoutService } from 'src/app/services/pre-checkout.service';
import { Utilitarios } from 'src/app/shared/utilitarios';
import { StateService } from 'src/app/state/state.service';
import { TranslateConfigService } from '../../services/translate-config.service';
import { PreCheckoutComponenteService } from './pre-checkout.componente.service';

const MOTORISTA_ADEQUADO = 'PERFIL ADEQUADO AO RISCO';
const DESCONHECIDO = 'DESCONHECIDO';
const PERFIL_EXPIRADO = 'PERFIL EXPIRADO';
const CPF_BLOQUEADO = 'CPF BLOQUEADO';
const PERFIL_COM_INSUFICIENCIA_DE_DADOS = 'PERFIL COM INSUFICIÊNCIA DE DADOS';

@Component({
  selector: 'app-pre-checkout',
  templateUrl: './pre-checkout.component.html',
  styleUrls: ['./pre-checkout.component.css']
})
export class PreCheckoutComponent implements OnInit {

  preCheckoutForm = this.formBuilder.group({
    cpf: ''
  });

  translation: any;
  formIsValid: boolean = true;
  status: PreCheckoutStatus = new PreCheckoutStatus();
  tentativa: number = 0;

  constructor(private formBuilder: FormBuilder,
    private translate: TranslateService,
    private preCheckoutService: PreCheckoutService,
    private router: Router,
    private stateService: StateService,
    private checkoutService: PreCheckoutComponenteService,
    private alertService: AlertService) { }

  ngOnInit(): void {
    //Limpa mensagem ao iniciar o componente
    this.alertService.limpaAlertMessage();

     this.translate.get("preCheckout").subscribe((res) => {
       this.translation = res;
     });
  }

  onSubmit(): void {
    this.validate();
    if (this.formIsValid){
      this.preCheckoutService.getMotorista(this.preCheckoutForm.value.cpf)
        .subscribe(
          (result) => {
            if(result.status.mensagem.includes(MOTORISTA_ADEQUADO)){

              this.checkoutService.set(result);
              
              this.stateService.updateHash(result.identificador);
              this.stateService.updateCpf(this.preCheckoutForm.value.cpf);
              this.stateService.updateName(result.detalhes.nome);
              //Limpa alert
              this.alertService.limpaAlertMessage();
              
              Utilitarios.NEXT_LEVEL="login";
              this.router.navigate(['/login']);
            }
            else if(result.status.mensagem == DESCONHECIDO){
              this.defineAlertMessages("CPF não cadastrado, entrar em contato com o transportador", null, "alert-warning");
            }
            else if(result.status.mensagem == PERFIL_EXPIRADO){
              this.defineAlertMessages("Seu perfil expirou, entrar em contato com o transportador", null, "alert-warning");
            }
            else if(result.status.mensagem == PERFIL_COM_INSUFICIENCIA_DE_DADOS){
              this.defineAlertMessages("Cadastro incompleto, entrar em contato com o transportador", null, "alert-warning");
            }
            else if(result.status.mensagem == CPF_BLOQUEADO){
              this.defineAlertMessages("Acesso bloqueado ao sistema, entrar em contato com o transportador", null, "alert-warning");
            }
            else{
              this.defineAlertMessages(Utilitarios.titleCase(result.status.mensagem), null, "alert-warning");
            }
          },
          (err) => {
            this.internalError(err);
          }
        );
    }
  }

  validate(){
    var form = document.getElementsByClassName('needs-validation')[0] as HTMLFormElement;
    this.formIsValid = form.checkValidity() && this.preCheckoutForm.valid;
    form.classList.add('was-validated');
  }

  internalError(err){
    this.alertDanger(this.translation.internalError,
      "");
    console.log(err)
  }

  defineAlertMessages(message, title, classAlert, showAlert: boolean = true){
    this.tentativa = this.alertService.defineAlertMessage(message, title, classAlert, showAlert, this.tentativa);
  }

  alertDanger(message, title){
    this.defineAlertMessages(message, title, "alert-danger");
  }

  invalidCpf() {
    return this.preCheckoutForm.controls.cpf.errors?.cpfNotValid && 
      this.preCheckoutForm.value.cpf.length == 11;
  }

  validForm() {
    return this.preCheckoutForm.valid;
  }
}